import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { UIModule } from '@app/modules/ui/ui.module'
import { Confirmable } from '@ui/models/confirmable'

@Component({
  selector: 'sb-read-receipts-modal',
  templateUrl: './read-receipts-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadReceiptsModalComponent extends Confirmable {
  @Input({ required: true }) headlineCopy!: string
  @Input({ required: true }) bodyCopy!: string
}
